import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import { Container, Header, Form, Button, Grid, Dimmer, Loader, Image, Segment, Input, Icon } from 'semantic-ui-react';
import { URL } from '../../../store/path'
import { post } from "axios";



const UploadXlsxForm = (props) => {

    const [fileObj, setFileObj] = useState();
    const [fileName, setFileName] = useState(true);
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [fileSelectColor, setFileSelectColor] = useState("blue");
    const [isWaiting, setWaiting] = useState(false);
    const [result, setResult] = useState("");
    const [resultColor, setResultColor] = useState("red");
   

    const onFormSubmit = e => {
        e.preventDefault(); // Stop form submit
        let nameFile = fileName.replace(/\./g, ';'),
            extention = nameFile.split(";")[1]
        if (extention.toString().toLowerCase() === "xlsx") {
            if (fileObj != null) {
                fileUpload().then(response => {
                    console.log(response.data, '---res.data');
                    setWaiting(false)
                    if (response.data.type == "error") {
                        setResultColor("red")
                        setResult(fileName + " : Uploaded with errors!")
                    }
                    else
                        setResultColor("green")
                    setResult(fileName + " : Successfully Uploaded!")
                    props.setXlResponse(response.data)
                    props.setAttachedFile(true)
                    resetForm()
                    setTimeout(() => {
                        props.setDisplayStatus(false)
                    }, 2000)

                });
                setWaiting(true)
            }
            else {
                console.log("Cannot upload")
                setResult("Error in Uploading, try again!")
            }
        } else {
            console.log("Cannot upload")
            setResult("Only Xlsx file allowed to upload")
        }

    };


    const fileChange = e => {
        // console.log("File chosen --->", e.target.files[0].name);
        setFileObj(e.target.files[0])
        setFileName(e.target.files[0].name)
        setFileSelectColor("white")
        setSubmitDisabled(false)
    };

    const resetForm = () => {
        setFileObj('')
        setFileName('')
        setFileSelectColor("blue")
        setSubmitDisabled(true)
    };

    const fileUpload = () => {

        const url = URL + "/upload/excel-upload";
        const formData = new FormData();
        formData.append("file", fileObj);
        // console.log("----------", formData)
        const config = { headers: { 'X-RLB-DMS-ACC': localStorage.getItem('acc') }, crossDomain: true, };
        return post(url, formData, config);
    };

    return (
        <Container >
            <Grid columns='equal'>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column width={5}>
                    </Grid.Column>
                    <Grid.Column width={6}>
                        <br /><br />
                        <Segment placeholder padded='very' color="blue" raised >
                            <Header icon>
                                <Icon name='file outline' color='green' />
                                <br />
                                Please upload XLSX files.
                            </Header>
                            <br />
                            <Form onSubmit={onFormSubmit}>
                                <Form.Field>
                                    {submitDisabled
                                        ? <Button as="label" htmlFor="file" type="button" size="large" style={{ color: "white" }} color={fileSelectColor}>
                                            Select File
                                        </Button>
                                        : <Button as="label" htmlFor="file" type="button" size="large" style={{ color: "black" }} >
                                            Select File
                                        </Button>
                                    }
                                    <Input type="file" id="file" style={{ display: "none" }} onChange={fileChange} />
                                    <p style={{ textAlign: 'center', paddingTop: "5px" }}>{fileName}</p>
                                </Form.Field>
                                <br />
                                {(submitDisabled)
                                    ? <Button type="submit" size="large" disabled >Upload</Button>
                                    : <Button type="submit" size="large" color="blue" >Upload</Button>
                                }
                            </Form>
                            {isWaiting
                                ? <Dimmer active inverted> <Loader indeterminate>Processing File</Loader> </Dimmer>
                                : null
                            }
                            <Link to={"/upload/list"}><p style={{ textAlign: 'center', paddingTop: "5px", color: `${resultColor}` }}>{result}</p></Link>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column width={5}>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    )
};

export default UploadXlsxForm;
